<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="收货图片" prop="receiptImages" required>
        <file-upload
          :file="form.receiptImages"
          type="image"
          :count="3"
          pathSrc="repair/receipt"
          :autoCropWidth="400"
          :autoCropHeight="300"
          @input="handleImageChange"
        />
        <div class="upload-tips">请上传收货图片，支持jpg、jpeg、png、gif格式，最多3张，每张不超过5MB</div>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注（选填）" :rows="3" :maxLength="150" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 确认收货 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { confirmReceipt } from '@/api/fix/devRepair'
import FileUpload from '@/components/FileUpload'

export default {
  name: 'ConfirmReceipt',
  components: {
    FileUpload,
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-确认收货',
      open: false,
      showLoading: false,

      // 表单参数
      form: {
        id: undefined,
        receiptImages: [],
        remark: '',
      },

      rules: {
        receiptImages: [
          { required: true, type: 'array', min: 1, message: '请至少上传一张收货图片', trigger: 'change' },
        ],
        remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    // 取消按钮
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        receiptImages: [],
        remark: '',
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },

    /** 打开抽屉 */
    init(record) {
      this.reset()
      this.form.id = record.id
      this.open = true
    },

    /** 处理图片上传变化 */
    handleImageChange(images) {
      this.form.receiptImages = images || []
    },

    /** 提交表单 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true

          // 这里应该调用确认收货的接口
          // 暂时模拟API调用
          this.$confirm({
            title: '确认收货?',
            content: '此操作将确认收到返修设备，状态将变为"处理中"，是否继续？',
            onOk: () => {
              // 调用确认收货接口
              this.confirmReceipt({
                id: this.form.id,
                receiptImages: this.form.receiptImages.join(','),
                remark: this.form.remark,
              }).then(() => {
                this.$message.success('确认收货成功', 3)
                this.open = false
                this.$emit('ok')
              }).catch(() => {
                // 错误处理
              }).finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
            },
            onCancel: () => {
              this.submitLoading = false
              this.showLoading = false
            },
          })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },

    // 确认收货接口
    confirmReceipt(data) {
      return confirmReceipt(data)
    },
  },
}
</script>

<style scoped>
.upload-tips {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
}

.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
</style>
